import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const BenefitsSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/5 via-transparent to-black/5" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why <span className="text-black">StockKhata</span>?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Built specifically for Indian stock market investors
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <Card className="group hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-white border-2 hover:border-black/20 overflow-hidden">
            <CardHeader className="pb-4">
              <div className="w-12 h-12 bg-black text-white rounded-lg flex items-center justify-center text-lg font-bold mb-3 group-hover:bg-black/90 transition-colors duration-300">
                01
              </div>
              <CardTitle className="text-xl font-bold text-gray-900 group-hover:text-black transition-colors duration-300">
                Accurate P&L Tracking
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600 leading-relaxed">
                Only calculate profit/loss on sold stocks. Unsold positions show neutral until you sell them.
              </p>
            </CardContent>
          </Card>
          
          <Card className="group hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-white border-2 hover:border-black/20 overflow-hidden">
            <CardHeader className="pb-4">
              <div className="w-12 h-12 bg-black text-white rounded-lg flex items-center justify-center text-lg font-bold mb-3 group-hover:bg-black/90 transition-colors duration-300">
                02
              </div>
              <CardTitle className="text-xl font-bold text-gray-900 group-hover:text-black transition-colors duration-300">
                Sector-wise Organization
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600 leading-relaxed">
                Organize your portfolio by market sectors to understand your investment distribution.
              </p>
            </CardContent>
          </Card>
          
          <Card className="group hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-white border-2 hover:border-black/20 overflow-hidden">
            <CardHeader className="pb-4">
              <div className="w-12 h-12 bg-black text-white rounded-lg flex items-center justify-center text-lg font-bold mb-3 group-hover:bg-black/90 transition-colors duration-300">
                03
              </div>
              <CardTitle className="text-xl font-bold text-gray-900 group-hover:text-black transition-colors duration-300">
                Real-time Data
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600 leading-relaxed">
                Get live stock prices and calculate real-time P&L on your current holdings.
              </p>
            </CardContent>
          </Card>
          
          <Card className="group hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-white border-2 hover:border-black/20 overflow-hidden">
            <CardHeader className="pb-4">
              <div className="w-12 h-12 bg-black text-white rounded-lg flex items-center justify-center text-lg font-bold mb-3 group-hover:bg-black/90 transition-colors duration-300">
                04
              </div>
              <CardTitle className="text-xl font-bold text-gray-900 group-hover:text-black transition-colors duration-300">
                Export & Analysis
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600 leading-relaxed">
                Export your data to CSV for external analysis or backup purposes.
              </p>
            </CardContent>
          </Card>
          
          <Card className="group hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-white border-2 hover:border-black/20 overflow-hidden">
            <CardHeader className="pb-4">
              <div className="w-12 h-12 bg-black text-white rounded-lg flex items-center justify-center text-lg font-bold mb-3 group-hover:bg-black/90 transition-colors duration-300">
                05
              </div>
              <CardTitle className="text-xl font-bold text-gray-900 group-hover:text-black transition-colors duration-300">
                Investment Calculators
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600 leading-relaxed">
                Plan your investments with SIP, Lumpsum, EMI, and PPF calculators.
              </p>
            </CardContent>
          </Card>
          
          <Card className="group hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-white border-2 hover:border-black/20 overflow-hidden">
            <CardHeader className="pb-4">
              <div className="w-12 h-12 bg-black text-white rounded-lg flex items-center justify-center text-lg font-bold mb-3 group-hover:bg-black/90 transition-colors duration-300">
                06
              </div>
              <CardTitle className="text-xl font-bold text-gray-900 group-hover:text-black transition-colors duration-300">
                Mobile Responsive
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600 leading-relaxed">
                Access your portfolio from any device - desktop, tablet, or mobile.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;